var _namedview, _linearGradient, _linearGradient2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulsesGranted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.352,
    height: 28.46,
    viewBox: "0 0 24.352 28.46",
    id: "svg3021",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview3023",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    pageshadow: 2,
    pageopacity: 0,
    pagecheckerboard: 0,
    showgrid: "false",
    zoom: 12.437288,
    cx: 8.2011447,
    cy: 21.226492,
    "window-width": 1920,
    "window-height": 1011,
    "window-x": 0,
    "window-y": 0,
    "window-maximized": 1,
    "current-layer": "svg3021"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs3014"
  }, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1015.968,
    x2: -1015.968,
    y2: 249.40096,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8164765,0,0,1.224775,839,-277)",
    y1: 226.16396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7f7f",
    id: "stop3007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6799cb",
    id: "stop3009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0af",
    id: "stop3011"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    collect: "always",
    xlinkHref: "#linearGradient2179",
    id: "linearGradient2181",
    x1: 190.53882,
    y1: 512.5625,
    x2: 190.53882,
    y2: 0.36148363,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.05543418,0,0,0.05543418,9.8900806e-5,4.9862547e-4)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    collect: "always",
    id: "linearGradient2179"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00aaff",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop2175"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff7f7f",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop2177"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    style: {
      mixBlendMode: "normal",
      fill: "url(#linearGradient2181)",
      fillOpacity: 1,
      strokeWidth: 0.0554342
    },
    d: "M 15.884263,0.00180398 C 15.493452,0.01949457 15.108918,0.1660875 14.795714,0.43876762 L 0.60597662,12.855946 c -0.55630911,0.487816 -0.75248156,1.269544 -0.49254904,1.962476 0.25993252,0.687383 0.92139232,1.147223 1.61043482,1.147223 h 6.2317495 l -4.2646412,9.945169 c -0.3265046,0.759448 -0.081916,1.646047 0.5882796,2.133864 0.6696504,0.487824 1.5862034,0.442887 2.2126109,-0.100363 L 20.683143,15.527137 c 0.554341,-0.487824 0.748032,-1.269552 0.443139,-1.962476 -0.21065,-0.687383 -0.876249,-1.147223 -1.613522,-1.147223 H 13.331963 L 17.595061,2.4738138 C 17.922119,1.7121435 17.677538,0.82699832 17.006781,0.33994899 16.671406,0.09651128 16.275074,-0.01588653 15.884263,0.00180398 Z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Direction_badge",
    "data-name": "Direction badge",
    transform: "rotate(180,110.3145,78.35)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(196.277,128.919)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    d: "M 4.869,8.037 H 2.909 A 0.366,0.366 0 0 1 2.541,7.675 v -3.5 H 0.369 A 0.361,0.361 0 0 1 0.109,3.556 l 3.523,-3.45 a 0.368,0.368 0 0 1 0.518,0 L 7.67,3.555 A 0.362,0.362 0 0 1 7.41,4.174 H 5.237 v 3.5 A 0.366,0.366 0 0 1 4.869,8.037 Z",
    transform: "rotate(-90,168.4685,-29.8685)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulsesGranted);
export default __webpack_public_path__ + "static/media/pulses_granted.05621e84e1adff6505989489a2e946c0.svg";
export { ForwardRef as ReactComponent };